import { createRouter, createWebHistory } from "vue-router";

import NotFound from "@/views/NotFound.vue";
import Roles from "@/views/roles/Roles.vue";

import GatesContainer from "@/views/GatesContainer.vue";
import GatesOverview from "@/views/gates/GatesOverview.vue";
import FreeDays from '@/views/freedays/FreeDays.vue';
import AddFreeDays from "@/views/freedays/AddFreeDays.vue";
import FreeDaysContainer from "@/views/FreeDaysContainer.vue";

import GateDetail from "@/views/gates/GatesDetail.vue";

import ObjectsContainer from "@/views/ObjectsContainer";
import ObjectsOverview from "@/views/objects/ObjectsOverview";
import ObjectDetail from "@/views/objects/ObjectDetail";

import EmergencyEquipmentOverview from "@/views/emergencyEquipment/EmergencyEquipmentOverview";
import EmergencyEquipmentAdd from "@/views/emergencyEquipment/EmergencyEquipmentAdd";
import EmergencyEquipmentDetail from "@/views/emergencyEquipment/EmergencyEquipmentDetail";
import EmergencyEquipmentContainer from "@/views/EmergencyEquipmentContainer.vue";

const routes = [
  {
    path: "/",
    redirect: { name: "GatesOverview" },
  },
  {
    path: "/poorten",
    component: GatesContainer,
    children: [
      {
        path: "",
        name: "GatesOverview",
        component: GatesOverview,
      },
      {
        path: ":id",
        name: "GateDetail",
        component: GateDetail,
      },
    ],
  },
  {
    path: "/objecten",
    component: ObjectsContainer,
    children: [
      {
        path: "",
        name: "ObjectsOverview",
        component: ObjectsOverview,
      },
      {
        path: ":id",
        name: "ObjectDetail",
        component: ObjectDetail,
      },
      {
        path: "toevoegen",
        name: "ObjectAdd",
        component: ObjectDetail,
      },
    ],
  },
  {
    path: "/noodmaterialen",
    component: EmergencyEquipmentContainer,
    children: [
      {
        path: "",
        name: "EmergencyEquipmentOverview",
        component: EmergencyEquipmentOverview,
      },
      {
        path: ":id",
        name: "EmergencyEquipmentDetail",
        component: EmergencyEquipmentDetail,
      },
      {
        path: "toevoegen",
        name: "EmergencyEquipmentAdd",
        component: EmergencyEquipmentAdd,
      },
    ],
  },
  {
    path: "/gebruikers",
    component: Roles,
    name: "Roles",
  },
  {
    path: '/vrijedagen',
    component: FreeDaysContainer,
    children: [
      {
        path: "",
        name: "FreeDays",
        component: FreeDays,
      },
      {
        path: 'toevoegen',
        component: AddFreeDays,
        name: 'AddFreeDays'
      }
    ]
  },
  { 
    path: "/:catchAll(.*)",
    component: NotFound,
    name: "NotFound",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
